// Currency conversion utilities

// Exchange rates (approximate, should be fetched from API in production)
export const EXCHANGE_RATES = {
  USD_TO_EUR: 0.95,  // 1 USD = 0.95 EUR
  CAD_TO_EUR: 0.68,  // 1 CAD = 0.68 EUR
  EUR_TO_BGN: 1.96,  // 1 EUR = 1.96 BGN
};

/**
 * Convert USD to EUR
 */
export const convertUsdToEur = (usdAmount: number): number => {
  return Math.round(usdAmount * EXCHANGE_RATES.USD_TO_EUR);
};

/**
 * Convert CAD to EUR
 */
export const convertCadToEur = (cadAmount: number): number => {
  return Math.round(cadAmount * EXCHANGE_RATES.CAD_TO_EUR);
};

/**
 * Convert EUR to BGN
 */
export const convertEurToBgn = (eurAmount: number): number => {
  return Math.round(eurAmount * EXCHANGE_RATES.EUR_TO_BGN);
};

/**
 * Convert price based on country to EUR
 * @param amount - Price amount
 * @param country - Country code (USA, CANADA)
 * @returns Price in EUR
 */
export const convertToEur = (amount: number, country?: string): number => {
  if (!amount) return 0;
  
  if (country === 'USA') {
    return convertUsdToEur(amount);
  } else if (country === 'CANADA') {
    return convertCadToEur(amount);
  }
  
  // Default to CAD conversion for backward compatibility
  return convertCadToEur(amount);
};

/**
 * Convert price based on country to BGN
 * @param amount - Price amount in original currency (USD/CAD)
 * @param country - Country code (USA, CANADA)
 * @returns Price in BGN
 */
export const convertToBgn = (amount: number, country?: string): number => {
  if (!amount) return 0;
  const eurAmount = convertToEur(amount, country);
  return convertEurToBgn(eurAmount);
};

// Legacy aliases
export const convertUsdToBgn = (usdAmount: number): number => {
  return convertEurToBgn(convertUsdToEur(usdAmount));
};

export const convertCadToBgn = (cadAmount: number): number => {
  return convertEurToBgn(convertCadToEur(cadAmount));
};

/**
 * Format price with BGN as main and EUR in small
 */
export const formatPriceDual = (amount: number, country?: string): { bgn: number; eur: number } => {
  const eurAmount = convertToEur(amount, country);
  const bgnAmount = convertEurToBgn(eurAmount);
  return { bgn: bgnAmount, eur: eurAmount };
};

/**
 * Format price with currency symbol (BGN)
 */
export const formatPrice = (amount: number, country?: string): string => {
  const bgnAmount = convertToBgn(amount, country);
  return `${bgnAmount.toLocaleString()} лв`;
};
